import axios from '@/jslib/axios'

export const login = data => {
  return axios({
    method: 'post',
    url: '/admin/login',
    data
  })
}

export const logout = params => {
  return axios({
    method: 'get',
    url: '/admin/logout',
    params
  })
}

export const refreshToken = data => {
  return axios({
    method: 'post',
    url: '/admin/refresh',
    data
  })
}

export const test = data => {
  return axios({
    method: 'get',
    url: '/api/v1/quote/benefit?class_id=11&rgtn_yr=2019&trm_of_cvr=2',
    data
  })
}
export const getListCount = data => {
  return axios({
    method: 'get',
    url: '/admin/list/data',
    data
  })
}
export const firstConfirmPassword = data => {
  return axios({
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    url: '/admin/confirm/password',
    data
  })
}
export const getVerifyCode = params => {
  return axios({
    method: 'get',
    url: '/admin/second/verify/code',
    params
  })
}
export const secondLogin = data => {
  return axios({
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    url: '/admin/second/login',
    data
  })
}


